import Head from "next/head";
import { useRouter } from "next/router";
import { useState } from "react";
import { toast } from "react-toastify";
import { routeKeys, buttonRouteKeys, BlobAssestsKeys, commonKeys } from "ui/data/constants/keys";
import { storeKeys, flowKeys, PolicyLogHeader } from "ui/data/constants/keys";
import { labels } from "ui/data/constants/labels";
import { alertMsgs } from "ui/data/constants/messages";
import { fetchQueriesAndFragements, setPolicy, setData } from "@cogitate/ui-utils-core-test";
import { AuthProvider } from '@cogitate/diep2-components-core';
import { fetchActionConfig, fetchRoleAuthorization, fetchUISchema, fetchvalidation } from "@cogitate/ui-utils-core-test/dist/utilities/shared/schemafromblob";
import { getInitialState } from "ui/components/initialData.js";
import { staticItems } from "ui/data/constants/static";
import { loadMastersByContainer } from "@cogitate/ui-utils-core-test/dist/utilities/shared/masters";
import { LoadPolicyByQuoteNumberAndVersion } from "ui/utilities/helper";
import { fetchDDMAgentUserInformationDetails, fetchDDMUWUserInformationDetails } from "ui/utilities/UserInformation";
import { getStoreState, setStoreState } from "@cogitate/ui-utils-core-test/dist/utilities/pages/shared";
import Cookies from 'js-cookie';
import { LoadDetails } from "@cogitate/ui-utils-core-test/dist/utilities/pages/dashboard";
import { getLoginUserName, getLoginUserRole } from "ui/redux/actions/modal/common/shared";

export default function Login() {
  const router = useRouter();
  const [loggedInUser, setLoggendInUser] = useState(getStoreState(storeKeys.LoggedInUserReducer));

  const jsonString = JSON.stringify(router.query);
  if(!(jsonString == '{}'|| jsonString.includes("token") || jsonString.includes("logout"))){
    Cookies.set('queryParams', encodeURIComponent(jsonString), { expires: 1, path: '/' });
  }

  const afterUserValidate = async () => {
    try {
      
      await setData({ buttonRouteKeys, routeKeys, staticItems , PolicyLogHeader });
      await loadMastersByContainer();
      await setPolicy(getInitialState());
      await fetchQueriesAndFragements();
      await fetchRoleAuthorization();
      await fetchActionConfig();
      await fetchvalidation();
      await fetchUISchema(
        process.env.NEXT_PUBLIC_CLIENT,
        process.env.NEXT_PUBLIC_DEFAULT_LINE,
        process.env.NEXT_PUBLIC_LINE_OF_BUSINESS,
        process.env.NEXT_PUBLIC_DEFAULT_STATE.toLowerCase(),
        process.env.NEXT_PUBLIC_DEFAULT_CARRIER.toLowerCase(),
        [
          flowKeys.Quote.toLowerCase(),
          flowKeys.Application.toLowerCase(),
          flowKeys.Endorsement.toLowerCase(),
          flowKeys.Modals.toLowerCase(),
          flowKeys.AccountHub.toLowerCase(),
        ],
        process.env.NEXT_PUBLIC_DEFAULT_VERSION.toLowerCase()
      );
      
      setStoreState(storeKeys.VersionReducer, {});

      const loginUserName = getLoginUserName();
      const loginUserRole = getLoginUserRole(false);

      const isAgentLogin = loginUserRole.toLowerCase() === commonKeys.RoleAgent.toLowerCase()
      await fetchDDMAgentUserInformationDetails(loginUserName, loginUserRole, isAgentLogin, true); 

      const isUWLogin = loginUserRole.toLowerCase() === commonKeys.RoleUnderwriter.toLowerCase()
      await fetchDDMUWUserInformationDetails(loginUserName, isUWLogin, true);

      const cookieValue = Cookies.get('queryParams');
      let route = routeKeys.DashboardAccountHub;
      if(cookieValue){
        const input = JSON.parse(decodeURIComponent(cookieValue));
        Cookies.remove('queryParams', { path: '/' });
        const resp = await LoadPolicyByQuoteNumberAndVersion(input);
        if(resp){
          await LoadDetails([resp], "view");
          if(resp.PolicyNumber == ''){
            const masterQuoteNumber = resp.ExternalRefrences.find(e=>e.ReferenceTarget == "Master_Policy_Ref")
            let MasterPolicy = await LoadPolicyByQuoteNumberAndVersion({QuoteNumber:masterQuoteNumber});
            if(MasterPolicy){
              setStoreState(storeKeys.VersionReducer, MasterPolicy);
            }
          }
          route = routeKeys.ValidateDocuments;
        }
      }
      if(route == routeKeys.DashboardAccountHub){
        const policyData = getInitialState();
        setStoreState(storeKeys.PolicyReducer, policyData);
      }
      
      router.push(route.toLowerCase()); //change
    } catch (error) {
      Cookies.remove('queryParams', { path: '/' });
    }
  }

  const onSuccess = async (userObj, resolvedurl, error) => {
    setStoreState(storeKeys.LoggedInUserReducer, userObj);
    if (!error) {
      await afterUserValidate();
    } else {
      toast.error(alertMsgs.Login.LoginFailed);
      router.push(routeKeys.Root);
    }
  }

  return (
    <>
      <Head>
        <title>{labels.Shared.Login.PageTitle}</title>
        <meta name="description" content="Developed By Team Cogitate" />
        <link
          rel="icon"
          href={`${process.env.NEXT_PUBLIC_BLOB_WEB_FILE_PATH}${BlobAssestsKeys.Login}`}
        />
      </Head>
      <AuthProvider
        AuthUrl={process.env.NEXT_PUBLIC_AUTH_SSO_URL + encodeURIComponent(process.env.NEXT_PUBLIC_PROJECT_URL)}
        UserStore={loggedInUser}
        onSuccess={onSuccess}>
        <div className="processContainer virtualBackground d-flex vh-100 justify-content-center align-items-center">
          <div className='processBox col-4 my-auto text-center pb-5 shadow rounded'>
            <h4 className='proHeader py-2'>Validating User</h4>
            <div className='proBody'>
              <div class="lds-ripple my-3"><div></div><div></div></div>
              <h5 className='mb-3' style={{ color: 'black' }}>Almost there...</h5>
            </div>
          </div>
        </div>
      </AuthProvider>
    </>
  );
}
Login.layout = "L1";
